export const translations = {
  en: {
    titleMain: "Sri 18m Padi",
    titleSub: "Karuppanasamy Temple",
    nav: {
      home: "Home",
      about: "About",
      poojaSchedule: "Pooja Schedule",
      events: "Events",
      gallery: "Gallery",
      imageGallery: "Image Gallery",
      videoGallery: "Video Gallery",
      contact: "Contact"
    },
    headerButton: "Temple Visit",
    home: {
      badge: "Sacred Heritage & Divine Blessings",
      heroTitle1: "About",
      heroTitle2: "Sri 18m Padi Karuppanasamy Temple",
      heroDesc: "Sri 18m Padi Karuppanasamy Temple is a sacred spiritual destination devoted to Lord Karuppanasamy, worshipped as the divine protector, guardian, and remover of obstacles. The temple stands as a symbol of faith, tradition, courage, and divine justice.",
      historyTag: "Temple History",
      historyTitle: "Sacred Spiritual Heritage",
      historyP1: "The temple is deeply rooted in Tamil spiritual traditions and cultural heritage. Devotees from different regions visit the temple seeking blessings for protection, prosperity, health, courage, and peace in life.",
      historyP2: "Lord Karuppanasamy is worshipped as a powerful guardian deity who protects devotees from negativity and guides them towards truth and righteousness.",
      historyP3: "The temple celebrates traditional poojas, sacred rituals, spiritual festivals, and special occasions with deep devotion and community participation.",
      divineTag: "Divine Experience",
      divineTitle: "Faith • Tradition • Devotion",
      divineFeatures: [
        "Daily Poojas & Rituals",
        "Special Festival Celebrations",
        "Spiritual Guidance & Blessings",
        "Traditional Tamil Cultural Heritage",
        "Sacred Darshan Experience",
        "Devotional Community Gatherings"
      ],
      quote1: "“May Lord Karuppanasamy bless every devotee with",
      quoteHighlight: " protection, prosperity, courage, and peace.",
      quote2: "”"
    },
    footer: {
      desc: "Experience divine blessings, sacred rituals, traditional poojas, and spiritual peace at Sri 18m Padi Karuppanasamy Temple.",
      address: "Sri 18m Padi Karuppanasamy Temple, Tamil Nadu, India",
      quickLinks: "Quick Links",
      updates: "Temple Updates",
      updatesDesc: "Subscribe to receive festival updates, pooja timings, temple announcements, and spiritual event notifications.",
      emailPlaceholder: "Enter your email",
      subscribe: "Subscribe Updates",
      subscribing: "Subscribing...",
      subscribeSuccess: "Subscribed! You will receive temple updates by email.",
      subscribeError: "Could not subscribe. Please try again later.",
      templeStatus: "Temple Open for Darshan",
      copyright: "© 2026 Sri 18m Padi Karuppanasamy Temple. All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions"
    },
    gallery: {
      imageTitle: "Sacred Temple Gallery",
      moments: "Sacred Moments",
      noImages: "No images in this category",
      videoTitle: "Video Gallery",
      videoSubtitle: "Experience the divine rituals, sacred ceremonies, and spiritual moments of Sri 18m Padi Karuppanasamy Temple through our curated video collection.",
      videoBadge: "Sacred Videos",
      categories: {
        all: "All Images",
        temple: "Sacred Space",
        rituals: "Divine Rituals",
        festival: "Sacred Festivals",
        deity: "Divine Darshan"
      }
    }
  },
  ta: {
    titleMain: "ஸ்ரீ 18ம் படி",
    titleSub: "கருப்பண்ணசாமி ஆலயம்",
    nav: {
      home: "முகப்பு",
      about: "பற்றி",
      poojaSchedule: "பூஜை நேரங்கள்",
      events: "நிகழ்வுகள்",
      gallery: "புகைப்படங்கள்",
      imageGallery: "புகைப்பட தொகுப்பு",
      videoGallery: "காணொளி தொகுப்பு",
      contact: "தொடர்பு"
    },
    headerButton: "ஆலய தரிசனம்",
    home: {
      badge: "புனித பாரம்பரியம் & தெய்வீக ஆசிகள்",
      heroTitle1: "பற்றி",
      heroTitle2: "ஸ்ரீ 18ம் படி கருப்பண்ணசாமி ஆலயம்",
      heroDesc: "ஸ்ரீ 18ம் படி கருப்பண்ணசாமி ஆலயம் என்பது கருப்பண்ணசாமியை வழிபடும் ஒரு புனிதமான ஆன்மீக தலமாகும். தீயவற்றை அழித்து நல்வழி காட்டும் காவல் தெய்வமாக மக்கள் கருப்பண்ணசாமியை வணங்குகின்றனர்.",
      historyTag: "கோவில் வரலாறு",
      historyTitle: "புனித ஆன்மீக பாரம்பரியம்",
      historyP1: "இந்த ஆலயம் தமிழ் ஆன்மீக பாரம்பரியம் மற்றும் கலாச்சார வேர்களைக் கொண்டது. பல்வேறு பகுதிகளில் இருந்து வரும் பக்தர்கள், வாழ்வில் பாதுகாப்பு, வளம் மற்றும் அமைதிக்காக இங்கு வந்து தரிசனம் செய்கின்றனர்.",
      historyP2: "கருப்பண்ணசாமி ஒரு சக்திவாய்ந்த காவல் தெய்வமாக வணங்கப்படுகிறார். அவர் பக்தர்களை எதிர்மறை ஆற்றல்களில் இருந்து பாதுகாத்து நெறிசார்ந்த வாழ்க்கைக்கு வழிகாட்டுகிறார்.",
      historyP3: "இந்த ஆலயத்தில் பாரம்பரிய பூஜைகள், புனித சடங்குகள் மற்றும் ஆன்மீக திருவிழாக்கள் பக்தர்களின் பெரும் பங்கேற்புடன் கோலாகலமாக கொண்டாடப்படுகின்றன.",
      divineTag: "தெய்வீக அனுபவம்",
      divineTitle: "நம்பிக்கை • பாரம்பரியம் • பக்தி",
      divineFeatures: [
        "தினசரி பூஜைகள் மற்றும் வழிபாடுகள்",
        "சிறப்பு திருவிழா கொண்டாட்டங்கள்",
        "ஆன்மீக வழிகாட்டுதல்கள் மற்றும் ஆசிகள்",
        "பாரம்பரிய தமிழ் கலாச்சாரம்",
        "புனித தரிசன அனுபவம்",
        "பக்திப்பூர்வமான மக்கள் கூடுகை"
      ],
      quote1: "“கருப்பண்ணசாமி ஒவ்வொரு பக்தருக்கும்",
      quoteHighlight: " பாதுகாப்பு, வளம் மற்றும் அமைதி வழங்கி அருள்புரிவாராக.",
      quote2: "”"
    },
    footer: {
      desc: "ஸ்ரீ 18ம் படி கருப்பண்ணசாமி கோவிலில் தெய்வீக ஆசிகள், புனித வழிபாடுகள் மற்றும் ஆன்மீக அமைதியை அனுபவித்திடுங்கள்.",
      address: "ஸ்ரீ 18ம் படி கருப்பண்ணசாமி ஆலயம், தமிழ்நாடு, இந்தியா",
      quickLinks: "விரைவான இணைப்புகள்",
      updates: "ஆலய முக்கிய தகவல்கள்",
      updatesDesc: "திருவிழா தகவல்கள், பூஜை நேரங்கள் மற்றும் பிற அறிவிப்புகளைப் பெற குழுசேரவும்.",
      emailPlaceholder: "மின்னஞ்சல் முகவரி",
      subscribe: "பதிவு செய்க",
      subscribing: "பதிவு செய்கிறது...",
      subscribeSuccess: "பதிவு செய்யப்பட்டது! கோவில் தகவல்களை மின்னஞ்சலில் பெறுவீர்கள்.",
      subscribeError: "பதிவு செய்ய முடியவில்லை. பிறகு மீண்டும் முயற்சிக்கவும்.",
      templeStatus: "ஆலயம் தரிசனத்திற்காக திறக்கப்பட்டுள்ளது",
      copyright: "© 2026 ஸ்ரீ 18ம் படி கருப்பண்ணசாமி ஆலயம். அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.",
      privacy: "தனியுரிமைக் கொள்கை",
      terms: "விதிமுறைகள் & நிபந்தனைகள்"
    },
    gallery: {
      imageTitle: "புனித கோவில் புகைப்பட தொகுப்பு",
      moments: "புனித தருணங்கள்",
      noImages: "இந்த பகுப்பில் புகைப்படங்கள் இல்லை",
      videoTitle: "காணொளி தொகுப்பு",
      videoSubtitle: "ஸ்ரீ 18ம் படி கருப்பண்ணசாமி ஆலயத்தின் தெய்வீக வழிபாடுகள், புனித சடங்குகள் மற்றும் ஆன்மீக தருணங்களை எங்கள் காணொளித் தொகுப்பின் வழியாக அனுபவியுங்கள்.",
      videoBadge: "புனித காணொளிகள்",
      categories: {
        all: "அனைத்து புகைப்படங்களும்",
        temple: "புனித தலம்",
        rituals: "தெய்வீக சடங்குகள்",
        festival: "புனித திருவிழாக்கள்",
        deity: "தெய்வீக தரிசனம்"
      }
    }
  }
};

export type Language = 'en' | 'ta';
